import { Link } from 'react-router-dom';
import { Reveal } from '../lib/site';
import badge from '../assets/brand/mgl-badge.svg';
import badgeDark from '../assets/brand/mgl-badge-dark.svg';

/* The card header: the site's one named section device.
   A pine square with a mono number, a mono label, then the heading. */
export function CardHeader({ no, label, dark = false }) {
  return (
    <div className={`ch${dark ? ' on-pine' : ''}`}>
      <span className="ch-no" aria-hidden="true">{no}</span>
      <span className="ch-label">{label}</span>
    </div>
  );
}

/* Clearly marked pre-launch placeholder. Only used for the items the
   build brief says must not be guessed. */
export function Tbd({ children }) {
  return (
    <div className="tbd">
      <span className="tbd-tag">TBD</span>
      <p>{children}</p>
    </div>
  );
}

/* Closing CTA band, used on every page so a demo is never far away. */
export function CtaBand({ title, sub }) {
  return (
    <section className="band-pine on-pine">
      <div className="wrap" style={{ padding: 'clamp(64px, 9vw, 110px) clamp(20px, 4.5vw, 44px)' }}>
        <Reveal style={{ maxWidth: 640 }}>
          <h2 className="h2">{title}</h2>
          <p className="lede" style={{ margin: '18px 0 30px' }}>{sub}</p>
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
            <Link to="/demo" className="btn btn-gold">Book a demo</Link>
            <Link to="/pricing" className="btn btn-line">See pricing</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* The real brand badge: gold golfer mark plus wordmark. The light-background
   variant sets the name in deep green, the dark variant in cream. */
export function Logo({ dark = false, height = 36 }) {
  // The badge SVGs carry only a viewBox (1107.47 x 422.41), no intrinsic
  // size, so the width must be set explicitly or browsers collapse it.
  return (
    <img
      src={dark ? badgeDark : badge}
      alt="MyGolfLinks"
      width={Math.round(height * 2.622)}
      height={height}
      style={{ display: 'block', maxWidth: 'none' }}
    />
  );
}

export function DemoLink({ className = 'btn btn-gold', children = 'Book a demo' }) {
  return <Link to="/demo" className={className}>{children}</Link>;
}
